import { forwardRef } from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 0.61, 0.36, 1];

export const Reveal = forwardRef(
  ({ children, className = "", delay = 0, y = 26, ...rest }, ref) => (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 0.75, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  ),
);

Reveal.displayName = "Reveal";

export default Reveal;
